import { Injectable } from '@angular/core';
import { Hotspot } from '../model/hotspot-models';

@Injectable({
  providedIn: 'root'
})
export class HotspotRegistry {
  // Hold all the loaded hotspot descriptions
  private hotspots: { [id: string]: Hotspot } = {};

  // Search the hotspot id on dictionary and return if found
  public getHotspotDetail(hotspotID: string): Hotspot {
    return this.hotspots[hotspotID];
  }

  private addHotspot(hotspot: Hotspot) {
    this.hotspots[hotspot.id] = hotspot;
  }

  public registerHotspots(hotspots: Hotspot | Array<Hotspot>) {
    if (Array.isArray(hotspots)) {
      hotspots.forEach((hotspot) => {
        this.addHotspot(hotspot);
      });
    } else {
      this.addHotspot(hotspots);
    }
  }
}
